import {combineReducers} from 'redux';
import {ACTION} from './constants';

const initialState = {}

function creationComponentReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION.GET_CASH_COMPONENT:
      return {
        ...action.data
      };
    case ACTION.GET_CASH_DATA:
      return {
        ...action.data
      };
    case ACTION.GET_REBALANCING_DATAWISE:
      return {...state,basket: {...action.data}
      };
    case ACTION.GET_REBALANCING_DATA:
      return {...state,basket: {...action.data}
      };
    default:
      return state;
  }
}

export default combineReducers({creationData: creationComponentReducer});
